import React from "react";
import {
    Box, Button, Text
} from "@chakra-ui/react";
import {URLPaths} from "../../config/application/URLPaths";
import {FixedSizeList as List} from "react-window";
import * as ReactWindow from "react-window";
import {OrderProductSimple} from "../../shared/entities/Order/Order";
import {MainButton} from "../../components/Buttons/MainButton";
import {ColumnConfig} from "../../components/Buttons/ColumnHandler";
import {ListProductItemConfig, ListProductItemRow} from "../../components/List/ListProductItem";
import {useNavigate} from "react-router";
import {format, parse} from "date-fns";
import ResponsivePopoverDrawer from "./ResponsivePopoverDrawer";
import {Product} from "../../shared/entities/Product/Product";

interface ExcludeSubscribePopoverProps {
    items: OrderProductSimple[];
    product?: Product;
}

const OrderDealershipPopover: React.FC<ExcludeSubscribePopoverProps> = ({items, product}) => {
    const navigate = useNavigate()

    const columns: Array<ColumnConfig> = [
        {
            header: "DATE",
            width: "40%",
        },
        {
            header: "ORDER",
            width: "30%",
        },
        {
            header: "QUANTITY",
            width: "30%",
        },

    ];

    const headers: Array<ListProductItemConfig> = columns.map(
        (col: ColumnConfig) => {
            return {
                content: col.header || "",
                width: col.width || "auto",
                isLink: col.isLink || false,
                style: col.style || {},
            };
        }
    );
    const parseDateString = (dateString: any) => {
        const parsedDate = parse(dateString, 'MM.dd.yyyy HH:mm', new Date());
        if (!parsedDate) {
            throw new RangeError('Invalid time value');
        }
        return parsedDate;
    };
    const renderRow = ({index, style}: ReactWindow.ListChildComponentProps) => {
        const elem = items[index];

        if (!elem) return null;
        const ItemConfig: Array<ListProductItemConfig> = [
            {
                content: format(parseDateString(elem?.createdAt), 'MM.dd.yyyy'),
            },
            {
                content: <Text
                    as="span"
                    fontSize={12}
                    fontWeight={'md'}
                    key={elem.id}
                    textDecoration="underline"
                    cursor="pointer"

                    _hover={{color: "gray.800", textDecoration: "unset"}}
                    onClick={() => navigate(`${URLPaths.ORDER_VIEW.link}${elem.id}`)}
                >
                    {elem.id}
                </Text>,
            },
            {
                content: elem.quantity,
            },
        ];

        return (
            <Box style={style} key={index}>
                <ListProductItemRow list={ItemConfig} headers={columns} style={{
                    background: "white",
                    justifyContent: "flex-start",
                    bgColor: 'white',
                    fontSize: "14px", minHeight: "30px"
                }}/>
            </Box>
        );
    };
    const renderFormContent = () => {
        return (
            <List
                height={300} // Высота видимой области
                itemCount={items.length} // Количество элементов в списке
                itemSize={35} // Высота одного элемента
                width="100%" // Ширина контейнера
            >
                {(props) => renderRow(props)}
            </List>
        )
    }
    return (
        <ResponsivePopoverDrawer
            trigger={
                <Button bg={"transparent"} _hover={{bg: "transparent"}} w="100%" p={0}
                        _active={{bg: "transparent"}}
                        onMouseDown={(e) => e.preventDefault()}>
                    <MainButton w="100%" border={"1px"}
                                height={{base: "40px", lg: "28px"}}>{`orders ${items.length}`}</MainButton>
                </Button>
            }
            header={
                <Box>
                    <Text fontSize={14} isTruncated fontWeight={"bold"} mr={4}>
                        {product?.name}
                    </Text>
                    <ListProductItemRow list={headers} noBorder={true}
                                        style={{fontSize: 14, fontWeight: "md", justifyContent: "flex-start"}}/>
                </Box>
            }
        >
            {renderFormContent()}
        </ResponsivePopoverDrawer>
    )
};

export default OrderDealershipPopover;
